import React from "react";

export default function Footer({ t }) {
  return (
    <footer className="py-12 bg-accent/5 border-t">
      <div className="container px-4 max-w-screen-xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-semibold mb-4">{t.footer.product}</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/#features"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.nav.features}
                </a>
              </li>
              <li>
                <a
                  href="/#workflow"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.nav.workflow}
                </a>
              </li>
              <li>
                <a
                  href="/#pricing"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.nav.pricing}
                </a>
              </li>
              <li>
                <a
                  href="/blog"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.nav.blog}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">{t.footer.company}</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/aboutUs"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.aboutUs}
                </a>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- placeholder, no careers page yet */}
                <a
                  href="#"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.careers}
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.nav.contact}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">{t.footer.resources}</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/blog"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.blog}
                </a>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- placeholder, no documentation page yet */}
                <a
                  href="#"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.documentation}
                </a>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- placeholder, no support page yet */}
                <a
                  href="#"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.support}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">{t.footer.legal}</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/docs/terms&Conditions"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.termsOfService}
                </a>
              </li>
              <li>
                <a
                  href="/docs/dataTreatment"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.privacyPolicy}
                </a>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid -- placeholder, no cookie policy page yet */}
                <a
                  href="#"
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {t.footer.cookiePolicy}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t text-center text-muted-foreground">
          <p>{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
